/** imported components

    * Helmet ===> for add specific title & CSS for the page.  
    * BreadcrumbsItem for ==> for dynamic breadcrumb.  
    * ./svg => imported for all svg elements  
    * ./styles => imported for using of all created styled components.
    * useState, useEffect ===> React hooks (useState is a way to get/set value)
    * data for ===> It is data component

**/
import React from "react";
import {Redirect} from "react-router-dom";
import { useState } from "react";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import { Helmet } from "react-helmet";
//import { TrainingWalkthrough } from "../learning-resource-walkthrough/training-walkthrough-view.js";
//import { AssessmentWalkthrough } from "../learning-resource-walkthrough/assessment-walkthrough.js";
//import { LossAnalysisWalkthrough } from "../learning-resource-walkthrough/loss-analysis-walkthrough.js";
//import { AssessmentResultWalkthrough } from "../learning-resource-walkthrough/AssessmentResultWalkthrough";
import data from "./data";

import {
  MainWrapper,
  LearningMainWrapper,
  CenterHeader,
  LHeading,
  LearningContainer,
  LeftLearningWrapper,
  RightLearningWrapper,
  LeftHeader,
  ArticleTab,
  LearnCardContainer,
  LearnCardCol,
  LearnCard,
  LCardDetails,
  MethologyTab,
  IndustryStudiesTab,
  WebcastTab,
  WebcastButton,
  RightHeader,
  RightCardContainer,
  PlatformCardCol,
  PlatformCard,
  PlatformDetail,
  FreeCounsulationButton,
} from "./styles";
export const LearningCenterView = (props) => {
  
  const [isActive, setIsActive] = useState(1);
  const [isTrainingWalkthrough, setIsTrainingWalkthrough] = useState(false);
  const [isAssessmentWalkthrough, setIsAssessmentWalkthrough] = useState(false);
  const [isLossAnalysisWalkthrough, setIsLossAnalysisWalkthrough] =
    useState(false);
  const [isResultTourWalkthrough, setResultTourWalkthrough] = useState(false);
  const handleArticleTab = (index) => {
    setIsActive(index);
    // setIsActive((isActive) => !isActive);
  };

  const handleClickWebcastButton = () => {
    // let webcastbtn = document.querySelector('[data-component="WebcastButton"]');

    let getWebcast = document.querySelector(".lai40-btn");
    getWebcast.click();
  };
  const handleLearnWalkthroughClick = (type) => {
    if (type == "TrainingWalkthrough") {
      return <Redirect to="/learning-training-walkthrough" />
      //setIsTrainingWalkthrough(true);
      // console.log(pData.platform_type === TrainingWalkthrough)
    } else if (type == "AssessmentWalkthrough") {
      setIsAssessmentWalkthrough(true);
    } else {
      setIsLossAnalysisWalkthrough(true);
    }
  };
  React.useEffect(()=>{
         props.handleExpandFal();
     },[]);
  return (
    <>
      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>Resource Center | SmarterChains</title>
        <meta name="description" content="Resource Center" />
      </Helmet>
      {!isLossAnalysisWalkthrough && 
        <>
          <BreadcrumbsItem to="/">Home</BreadcrumbsItem>
          <BreadcrumbsItem to="/p">Resource Center</BreadcrumbsItem>
        </>
      }

      <MainWrapper
        data-component="MainWrapper"
        style={{ display: isLossAnalysisWalkthrough ? "none" : "" }}
      >
        <LearningMainWrapper
          data-component="LearningMainWrapper"
          style={{ display: isResultTourWalkthrough ? "none" : "" }}
        >
          <CenterHeader data-component="CenterHeader">
            <LHeading data-component="Heading">Resource Center</LHeading>
            <FreeCounsulationButton data-component="FreeCounsulationButton">
              <span>FREE Consultation Call</span>
            </FreeCounsulationButton>
          </CenterHeader>
          <LearningContainer data-component="LearningContainer">
            <LeftLearningWrapper data-component="LeftLearningWrapper">
              <LeftHeader data-component="LeftHeader">
                <ArticleTab
                  data-component="ArticleTab"
                  className={isActive === 1 ? "active" : ""}
                  onClick={(e) => handleArticleTab(1)}
                >
                  {" "}
                  <span>Methodology</span>{" "}
                </ArticleTab>
                <ArticleTab
                  data-component="ArticleTab "
                  className={isActive === 2 ? "active" : ""}
                  onClick={(e) => handleArticleTab(2)}
                >
                  {" "}
                  <span> Industry 4.0 Studies</span>{" "}
                </ArticleTab>
                <ArticleTab
                  data-component="ArticleTab "
                  className={isActive === 3 ? "active" : ""}
                  onClick={(e) => handleArticleTab(3)}
                >
                  {" "}
                  <span>Webcasts</span>{" "}
                </ArticleTab>
              </LeftHeader>
              <MethologyTab
                data-component="MethologyTab"
                open={isActive == 1 ? "open" : ""}
              >
                <LearnCardContainer data-component="LearnCardContainer">
                  <LearnCardCol data-component="LearnCardCol">
                    <LearnCard data-component="LearnCard" to="/framework">
                      <div className="card_img">
                        <img
                          src={
                            require("../../assets/img/resource-center/methology/factory-future.svg")
                              .default
                          }
                          alt=""
                        />
                      </div>
                      <LCardDetails data-component="LCardDetails">
                        <h1>Factory of the Future Framework</h1>
                        <p>The 4 step methodology of SmarterChains.</p>
                      </LCardDetails>
                    </LearnCard>
                  </LearnCardCol>
                  <LearnCardCol data-component="LearnCardCol">
                    <LearnCard
                      data-component="LearnCard"
                      to="/industry-40-dimensions"
                    >
                      <div className="card_img">
                        <img
                          src={
                            require("../../assets/img/resource-center/methology/industry-dimension.svg")
                              .default
                          }
                          alt=""
                        />
                      </div>
                      <LCardDetails data-component="LCardDetails">
                        <h1>Industry 4.0 Dimensions</h1>
                        <p>The cornerstone of SmarterChains Framework.</p>
                      </LCardDetails>
                    </LearnCard>
                  </LearnCardCol>
                  <LearnCardCol data-component="LearnCardCol">
                    <LearnCard data-component="LearnCard" to="/digital-plant">
                      <div className="card_img">
                        <img
                          src={
                            require("../../assets/img/resource-center/methology/plant-archetypes.svg")
                              .default
                          }
                          alt=""
                        />
                      </div>
                      <LCardDetails data-component="LCardDetails">
                        <h1>Industry 4.0 Plant Archetypes</h1>
                        <p>A 4 way classification of manufacturing plants.</p>
                      </LCardDetails>
                    </LearnCard>
                  </LearnCardCol>
                </LearnCardContainer>
              </MethologyTab>
              <IndustryStudiesTab
                data-component="IndustryStudiesTab"
                open={isActive == 2}
              >
                <LearnCardContainer data-component="LearnCardContainer">
                  <LearnCardCol data-component="LearnCardCol">
                    <LearnCard data-component="LearnCard" to="/cpgstudy">
                      <div className="card_img">
                        <img
                          src={
                            require("../../assets/img/resource-center/industry-4.0-studies/cpg-study.svg")
                              .default
                          }
                          alt=""
                        />
                      </div>
                      <LCardDetails data-component="LCardDetails">
                        <h1>CPG Industry Study</h1>
                        <p>A benchmarking study for the CPG Industry.</p>
                      </LCardDetails>
                    </LearnCard>
                  </LearnCardCol>
                  <LearnCardCol data-component="LearnCardCol">
                    {
                      <LearnCard data-component="LearnCard" to="/whitepaper">
                        <div className="card_img">
                          <img
                            src={
                              require("../../assets/img/resource-center/industry-4.0-studies/cpg-factory.svg")
                                .default
                            }
                            alt=""
                          />
                        </div>
                        <LCardDetails data-component="LCardDetails">
                          <p className="cpg-txt">
                            An Industry 4.0 Framework to Create Smart and
                            Sustainable Factories
                          </p>
                        </LCardDetails>
                      </LearnCard>
                    }
                  </LearnCardCol>
                </LearnCardContainer>
              </IndustryStudiesTab>
              <WebcastTab data-component="WebcastTab" open={isActive == 3}>
                <LearnCardContainer data-component="LearnCardContainer">
                  <LearnCardCol data-component="LearnCardCol">
                    <WebcastButton
                      data-component="WebcastButton"
                      onClick={handleClickWebcastButton}
                    >
                      <div className="card_img">
                        <img
                          src={
                            require("../../assets/img/resource-center/webcast/smarterChains-webcast.svg")
                              .default
                          }
                          alt=""
                        />
                      </div>
                      <LCardDetails data-component="LCardDetails">
                        {/* <h1></h1> */}
                        <p className="cpg-txt">
                          4 steps for Industry 4.0 transformation
                        </p>
                      </LCardDetails>
                    </WebcastButton>
                  </LearnCardCol>
                </LearnCardContainer>
              </WebcastTab>
            </LeftLearningWrapper>
            <RightLearningWrapper data-component="RightLearningWrapper">
              <RightHeader data-component="RightHeader">
                <span>Platform Tools Tours</span>
              </RightHeader>
              <RightCardContainer data-component="RightCardContainer">
                {data.map((pData) => (
                  <PlatformCardCol data-component="PlatformCardCol">
                    <PlatformCard
                      as={!pData.url?"button":''}
                      data-component="PlatformCard"
                      to={pData.url}
                    >
                      <div className="pcard-img">
                        <img
                          src={pData.path}
                          alt=""
                          className={pData["img-class"]}
                        />
                      </div>
                      <PlatformDetail data-component="PlatformDetail">
                        <h1 className={pData["engage-class"]}>
                          {pData.platform}
                        </h1>
                        <p>{pData["engage-time"]}</p>
                      </PlatformDetail>
                    </PlatformCard>
                  </PlatformCardCol>
                ))}
              </RightCardContainer>
            </RightLearningWrapper>
          </LearningContainer>
        </LearningMainWrapper>
        {/*
              <TrainingWalkthrough
                  open={isTrainingWalkthrough}
                  handlePopup={setIsTrainingWalkthrough}
                />
                
                <AssessmentWalkthrough
                  open={isAssessmentWalkthrough}
                  handlePopup={setIsAssessmentWalkthrough}
                  activeResult={setResultTourWalkthrough}
                />
                <AssessmentResultWalkthrough
                  open={isResultTourWalkthrough}
                  handlePopup={setResultTourWalkthrough}
                  activeResult={setIsAssessmentWalkthrough}
                />
          */}
              </MainWrapper>
              {/*<LossAnalysisWalkthrough
                open={isLossAnalysisWalkthrough}
                handlePopup={setIsLossAnalysisWalkthrough}
              />*/}
         
    </>
  );
};
